export default __webpack_public_path__ + "static/media/asuwayda.79ca1cda.jpg";